module.exports = __webpack_public_path__ + "static/media/chubb.fcd66841.svg";